import type { ServerContextProps } from "./types"

import { createContext } from "react"

export const ServerContext = createContext<ServerContextProps | undefined>(undefined)
